"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var AXSBlock_1 = __importDefault(require("../../layout/AXSBlock/AXSBlock"));
var styled_components_1 = __importDefault(require("styled-components"));
var classnames_1 = __importDefault(require("classnames"));
var AXSFlex_1 = __importDefault(require("../../layout/AXSFlex"));
var colors_1 = require("../../constants/colors");
var utils_1 = require("../../utils");
var Div = styled_components_1.default(AXSFlex_1.default)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  min-height: 65px;\n  position: relative;\n  align-items: center;\n  overflow: hidden;\n\n  &:before {\n    content: \"\";\n    width: 6px;\n    background-color: ", ";\n    height: 66px;\n    left: -40px;\n    top: 0;\n    position: absolute;\n    display: ", ";\n  }\n\n  @media (max-width: 640px) {\n    margin: 0;\n    min-height: 80px;\n\n    &:before {\n      content: \"\";\n      width: 6px;\n      background-color: ", ";\n      height: 81px;\n      left: 0;\n      top: 0;\n      position: absolute;\n      display: ", ";\n    }\n  }\n"], ["\n  min-height: 65px;\n  position: relative;\n  align-items: center;\n  overflow: hidden;\n\n  &:before {\n    content: \"\";\n    width: 6px;\n    background-color: ",
    ";\n    height: 66px;\n    left: -40px;\n    top: 0;\n    position: absolute;\n    display: ", ";\n  }\n\n  @media (max-width: 640px) {\n    margin: 0;\n    min-height: 80px;\n\n    &:before {\n      content: \"\";\n      width: 6px;\n      background-color: ",
    ";\n      height: 81px;\n      left: 0;\n      top: 0;\n      position: absolute;\n      display: ", ";\n    }\n  }\n"])), function (_a) {
    var sideBorder = _a.sideBorder, theme = _a.theme;
    return sideBorder ? theme[sideBorder] : colors_1.colors.WHITE;
}, function (_a) {
    var sideBorder = _a.sideBorder;
    return (sideBorder ? 'block' : 'none');
}, function (_a) {
    var sideBorder = _a.sideBorder, theme = _a.theme;
    return sideBorder ? theme[sideBorder] : colors_1.colors.WHITE;
}, function (_a) {
    var sideBorder = _a.sideBorder;
    return (sideBorder ? 'block' : 'none');
});
var LocatorWrapper = styled_components_1.default(AXSFlex_1.default)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  background-color: ", ";\n  border: ", ";\n  height: ", ";\n  padding: ", ";\n  width: 100%;\n"], ["\n  background-color: ",
    ";\n  border: ", ";\n  height: ", ";\n  padding: ", ";\n  width: 100%;\n"])), function (_a) {
    var backgroundColor = _a.backgroundColor, theme = _a.theme, simple = _a.simple, outlined = _a.outlined;
    return simple || outlined ? 'transparent' : utils_1.parseThemePath(backgroundColor, theme, colors_1.colors.BLUE_MEDIUM_300);
}, function (_a) {
    var outlined = _a.outlined;
    return outlined ? "2px solid " + colors_1.colors.BLUE_MEDIUM_300 : 'none';
}, function (_a) {
    var simple = _a.simple;
    return simple ? 'auto' : '70px';
}, function (_a) {
    var simple = _a.simple;
    return simple ? 0 : '14px 25px 0 35px';
});
var LocatorColumn = styled_components_1.default(AXSBlock_1.default)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  color: ", ";\n  font-size: ", ";\n  font-weight: ", ";\n  text-align: ", ";\n  width: 100%;\n"], ["\n  color: ",
    ";\n  font-size: ", ";\n  font-weight: ", ";\n  text-align: ", ";\n  width: 100%;\n"])), function (_a) {
    var color = _a.color, theme = _a.theme, simple = _a.simple, outlined = _a.outlined;
    return utils_1.parseThemePath(color, theme, (simple ? colors_1.colors.GREY_650 : (outlined ? colors_1.colors.BLUE_MEDIUM_300 : colors_1.colors.WHITE)));
}, function (_a) {
    var simple = _a.simple;
    return simple ? '13px' : '26px';
}, function (_a) {
    var simple = _a.simple;
    return simple ? '400' : '700';
}, function (_a) {
    var align = _a.align;
    return align;
});
var Label = styled_components_1.default(AXSBlock_1.default)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  color: ", ";\n  display: block;\n  font-size: ", ";\n  font-weight: ", ";\n  line-height: 16px;\n  text-transform: uppercase;\n"], ["\n  color: ",
    ";\n  display: block;\n  font-size: ", ";\n  font-weight: ", ";\n  line-height: 16px;\n  text-transform: uppercase;\n"])), function (_a) {
    var theme = _a.theme, labelColor = _a.labelColor, simple = _a.simple, outlined = _a.outlined;
    return utils_1.parseThemePath(labelColor, theme, (simple ? '#6c6c6c' : (outlined ? colors_1.colors.BLUE_MEDIUM_300 : colors_1.colors.WHITE)));
}, function (_a) {
    var simple = _a.simple;
    return simple ? '11px' : '12px';
}, function (_a) {
    var simple = _a.simple;
    return simple ? '300' : '400';
});
var Notch = styled_components_1.default.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    background-color: white;\n    border-bottom-right-radius: 50px;\n    border-top-right-radius: 50px;\n    border: ", ";\n    height: 50px;\n    left: -15px;\n    top: 10px;\n    width: 25px;\n    position: absolute;\n    z-index: 1;\n"], ["\n    background-color: white;\n    border-bottom-right-radius: 50px;\n    border-top-right-radius: 50px;\n    border: ", ";\n    height: 50px;\n    left: -15px;\n    top: 10px;\n    width: 25px;\n    position: absolute;\n    z-index: 1;\n"])), function (_a) {
    var outlined = _a.outlined;
    return outlined ? '2px solid #0054a1' : 'none';
});
var AXSSeatLocator = function (_a) {
    var deliveryMethod = _a.deliveryMethod, section = _a.section, sectionColor = _a.sectionColor, row = _a.row, rowColor = _a.rowColor, seat = _a.seat, seatColor = _a.seatColor, labelColor = _a.labelColor, theme = _a.theme, className = _a.className, outlined = _a.outlined, simple = _a.simple, backgroundColor = _a.backgroundColor, props = __rest(_a, ["deliveryMethod", "section", "sectionColor", "row", "rowColor", "seat", "seatColor", "labelColor", "theme", "className", "outlined", "simple", "backgroundColor"]);
    return (React.createElement(Div, __assign({}, props, { className: classnames_1.default(['c-axs-seat-locator', className]) }),
        !simple ? React.createElement(Notch, { outlined: outlined }) : null,
        React.createElement(LocatorWrapper, { backgroundColor: backgroundColor, outlined: outlined, simple: simple },
            section && (React.createElement(LocatorColumn, { color: sectionColor, outlined: outlined, simple: simple, align: "left", className: "c-axs-seat-locator__section locator-column" },
                React.createElement(Label, { labelColor: labelColor, theme: theme, simple: simple, outlined: outlined }, "Sec"),
                section)),
            row && (React.createElement(LocatorColumn, { color: rowColor, outlined: outlined, simple: simple, align: "center", className: "c-axs-seat-locator__row locator-column" },
                React.createElement(Label, { labelColor: labelColor, theme: theme, simple: simple, outlined: outlined }, "Row"),
                row)),
            seat && (React.createElement(LocatorColumn, { simple: simple, outlined: outlined, color: seatColor, align: "right", className: "c-axs-seat-locator__seat locator-column" },
                React.createElement(Label, { labelColor: labelColor, theme: theme, simple: simple, outlined: outlined }, "Seat"),
                seat)))));
};
AXSSeatLocator.defaultProps = {
    labelColor: 'axsui.components.seatLocator.labelColor',
    rowColor: 'axsui.components.seatLocator.rowColor',
    seatColor: 'axsui.components.seatLocator.seatColor',
    sectionColor: 'axsui.components.seatLocator.sectionColor',
};
exports.default = AXSSeatLocator;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
//# sourceMappingURL=index.js.map